Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});

/**
 * Get a list of possible event messages from a Sentry event.
 */
function getPossibleEventMessages(event) {
  var possibleMessages = [];
  if (event.message) {
    possibleMessages.push(event.message);
  }
  try {
    // @ts-expect-error Try catching to save bundle size
    var lastException = event.exception.values[event.exception.values.length - 1];
    if (lastException !== null && lastException !== void 0 && lastException.value) {
      possibleMessages.push(lastException.value);
      if (lastException.type) {
        possibleMessages.push("".concat(lastException.type, ": ").concat(lastException.value));
      }
    }
  } catch (e) {
    // ignore errors here
  }
  return possibleMessages;
}
exports.getPossibleEventMessages = getPossibleEventMessages;